import { rethrowNativeError } from "../nativeError";
import { Directory, File, FileHandle, FileMode, Paths } from "./classes.native";
import { fileSystemNative as native } from "./hybrid.native";
function getDirectories() {
  try {
    return native().getDirectories();
  } catch (error) {
    return rethrowNativeError(error);
  }
}
function getInfo(uri) {
  return native().getInfo(uri).catch(rethrowNativeError);
}
function readDirectory(uri) {
  return native().readDirectory(uri).catch(rethrowNativeError);
}
function makeDirectory(uri) {
  var intermediates = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  return native().makeDirectory(uri, intermediates).catch(rethrowNativeError);
}
function writeFile(uri, contents) {
  var encoding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "utf8";
  return native().writeFile(uri, contents, encoding).catch(rethrowNativeError);
}
function copy(fromUri, toUri) {
  return native().copy(fromUri, toUri).catch(rethrowNativeError);
}
function move(fromUri, toUri) {
  return native().move(fromUri, toUri).catch(rethrowNativeError);
}
function deleteFile(uri) {
  return native().remove(uri).catch(rethrowNativeError);
}
var FileSystem = Object.freeze({
  getDirectories,
  getInfo,
  readDirectory,
  makeDirectory,
  writeFile,
  copy,
  move,
  delete: deleteFile,
  File,
  Directory,
  Paths,
  FileHandle,
  FileMode
});
export {
  FileSystem
};
//# sourceMappingURL=index.native.js.map
